import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {routeHelper} from '#config/routeKeys'
import MenuItem from '../MenuItem'

function AusbildungsplanStaticPages(props) {
  const {pageList, currentItem, contextualUserId} = props
  return (
    <div data-menu="static">
      <h3 className="menu__item--headline">{i18n.t('ausbildungsplan_submenu_general_info')}</h3>
      <ul className="menu__level">
        {pageList.map(page => (
          <li key={page.id} className="menu__item">
            <MenuItem
              text={page.text}
              lead={page.lead}
              active={currentItem === page.id}
              url={routeHelper.ausbildungsplanStaticChapter(contextualUserId, page.id)}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

AusbildungsplanStaticPages.propTypes = {
  pageList: PropTypes.arrayOf(PropTypes.shape({id: PropTypes.string})),
  currentItem: PropTypes.string,
  contextualUserId: PropTypes.number.isRequired,
}

export default AusbildungsplanStaticPages
